/*
 * DisplayUserInfo.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-10-09 in huWaWi3 33.1.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import React from 'react'

export const DisplayUserInfo = (props: Record<string, any>) => {
  return (
    <span>
      {props?.user} / {props?.uid}
    </span>
  )
}
